import React, {Component} from 'react';
import './LeftPanel.css';
import {ThreeBarsIcon, XIcon, CheckCircleFillIcon, AlertFillIcon} from '@primer/octicons-react';
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import recent from '../../assets/images/recent.png';
import older from '../../assets/images/older.png';
import rrecent from '../../assets/images/rrecent.png';
import rolder from '../../assets/images/rolder.png';

const textes = {
    'informations': {
        'fr': 'Informations',
        'de': 'Informationen',
        'it': 'Informazioni',
        'en': 'Informations'
    },
    'statut': {
        'fr': 'Statut Liste Rouge',
        'de': 'Rote Liste Status',
        'it': 'Status Lista Rossa',
        'en': 'Red List status'
    },
    'priorite': {
        'fr': 'Espèce prioritaire nationale',
        'de': 'National prioritäre Art',
        'it': 'Specie prioritaria nazionale',
        'en': 'National priority species'
    },
    'uzl': {
        'fr': 'UZL',
        'de': 'UZL',
        'it': 'UZL',
        'en': 'UZL'
    },
    'wzl': {
        'fr': 'WZL',
        'de': 'WZL',
        'it': 'WZL',
        'en': 'WZL'
    },
    'origine': {
        'fr': 'Origine',
        'de': 'Herkunft',
        'it': 'Origine',
        'en': 'Origin'
    },
    'indigene': {
        'fr': '(indigène)',
        'de': '(einheimisch)',
        'it': '(indigena)',
        'en': '(native)'
    },
    'introduite': {
        'fr': '(Introduite)',
        'de': '(eingeführt)',
        'it': '(introdotta)',
        'en': '(introduced)'
    },
    'images': {
        'fr': 'Images',
        'de': 'Bilder',
        'it': 'Immagini',
        'en': 'Pictures'
    },
    'legende': {
        'fr': 'Légende',
        'de': 'Legende',
        'it': 'Didascalia',
        'en': 'Legend'
    },
    'obsavant': {
        'fr': 'Données avant',
        'de': 'Daten vor',
        'it': 'Dati prima',
        'en': 'Data before'
    },
    'obsapres': {
        'fr': 'Données après',
        'de': 'Daten ab',
        'it': 'Dati dopo',
        'en': 'Data since'
    },
    'allochtone': {
        'fr': 'allochtones',
        'de': 'standortfremd',
        'it': 'introdotti',
        'en': 'allochthonous'
    },
    'portrait': {
        'fr': 'Portrait',
        'de': 'Porträt',
        'it': 'Ritratto',
        'en': 'Portrait'
    },
    'atlas': {
        'fr': 'Atlas de la faune de Suisse',
        'de': 'Atlas der Schweizer Fauna',
        'it': 'Atlas de la faune de Suisse',
        'en': 'Atlas de la faune de Suisse'
    }
};

const establishmentmeans = {
  "IEN": {
    "fr": "indigène endémique",
    "de": "einheimisch, endemisch",
    "it": "indigena, endemismo",
    "en": "native"
  },
  "IEP": {
    "fr": "indigène endémique partagé",
    "de": "einheimisch, teilendemisch",
    "it": "indigena, endemismo condiviso",
    "en": "native"
  },
  "INN": {
    "fr": "indigène",
    "de": "einheimisch",
    "it": "indigena",
    "en": "native"
  },
  "INR": {
    "fr": "indigène, régionalement introduite",
    "de": "einheimisch, regional eingeführt",
    "it": "indigena, regionalmente introdotta",
    "en": "native"
  },
  "INM": {
    "fr": "indigène, migratrice",
    "de": "einheimisch, wandernd",
    "it": "indigena, migrante",
    "en": "native"
  },
  "NEO": {
    "fr": "introduite",
    "de": "eingeführt",
    "it": "introdotta",
    "en": "introduced"
  },
  "NLI": {
    "fr": "introduite, invasive",
    "de": "eingeführt, invasiv",
    "it": "introdotta, invasiva",
    "en": "introduced, invasive"
  },
  "NLS": {
    "fr": "introduite, invasive",
    "de": "eingeführt, invasiv",
    "it": "introdotta, invasiva",
    "en": "introduced"
  },
  "NLV": {
    "fr": "introduite, interdite selon ODE",
    "de": "eingeführt, verboten nach FrSV",
    "it": "introdotta, vietata da OEDA",
    "en": "introduced"
  },
  "OTH": {
      "fr": "[sans attribution]",
      "de": "[Zuordnung ausstehend]",
      "it": "[sans attribution]"
    }
};


class LeftPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            openClass: props.nuesp ? 'left-panel' : 'left-panel left-panel-close',
            iconClass: 'left-panel-icon',
            panelHidden: !props.nuesp,
            nuesp: props.nuesp,
            panelDisabled: true,
            species: [],
            locale: props.locale,
            images: [],
            isOpen: false,
            photoIndex: 0,
            yrChange: props.yrChange
        };
        
        if (props.nuesp) {
            fetch('https://lepus.infofauna.ch/carto-old/getnuespinfo-json.php?nuesp=' + props.nuesp)
                .then(response => response.json())
                .then(data =>
                    this.setState({
                        species: data[0]
                    })
                )
                .catch(error => this.setState({error, isLoading: false}));

            fetch('https://lepus.infofauna.ch/carto-old/getimageinfo.php?nuesp=' + props.nuesp)
                .then(response => response.json())
                .then(data =>
                    this.setState({
                        images: data,
                        isLoading: false,
                        panelDisabled: false
                    })
                )
                .catch(error => this.setState({error, isLoading: false}));
        }

        this.openPanel = this.openPanel.bind(this);
        this.closePanel = this.closePanel.bind(this);
    }

    openPanel(e) {
        this.setState({
            openClass: 'left-panel',
            panelHidden: !this.state.panelHidden
        })
    }

    closePanel(e) {
        this.setState({
            openClass: 'left-panel left-panel-close',
            panelHidden: !this.state.panelHidden
        })
    }

    openLighbox(image) {
        this.setState({
            isOpen: true,
            photoIndex: this.state.images.indexOf(image)
        })
    }

    shouldComponentUpdate(nextProps, nextState) {
        /*
        A VERIFIER
        Le if ci-dessous doit toujours être false car je n'ai pas trouvé de cas où :
        this.props.nuesp!==nextProps.nuesp
        Les deux fetchs ci-dessous se font à chaque fois dans le constructor
        car à chaque fois que l'on fait une nouvelle recherche on fait appel au constructor.
        Approche à vérifier.
        */
        if (this.props.nuesp !== nextProps.nuesp) {
            this.setState({
                nuesp: nextProps.nuesp,
                photoIndex: 0,
                openClass: 'left-panel',
                panelHidden: false
            });

            fetch('https://lepus.infofauna.ch/carto-old/getnuespinfo-json.php?nuesp=' + nextProps.nuesp)
                .then(response => response.json())
                .then(data =>
                    this.setState({
                        species: data[0]
                    })
                )
                .catch(error => this.setState({error, isLoading: false}));

            fetch('https://lepus.infofauna.ch/carto-old/getimageinfo.php?nuesp=' + nextProps.nuesp)
                .then(response => response.json())
                .then(data =>
                    this.setState({
                        images: data,
                        isLoading: false,
                        panelDisabled: false
                    })
                )
                .catch(error => this.setState({error, isLoading: false}));
        }

        if (this.props.locale !== nextProps.locale) {
            this.setState({
                locale: nextProps.locale
            });
        }

        if (this.props.yrChange !== nextProps.yrChange) {
            this.setState({
                yrChange: nextProps.yrChange
            });
        }

        return true;
    }

    render() {
        const {isOpen, photoIndex, images} = this.state;
        
        const text = this.state.species[`niv_con_${this.state.locale}`];
        
        const linkedText = text?.replace(/[A-Z]+ [A-Z’]+/g, (match) => {
            if(this.state.locale==='fr') {
                return `<a href="https://www.infofauna.ch/fr/donnees/demander-des-donnees#serveurcarto" target="_blank" class="left-panel-link" rel="noreferrer noopener">${match}</a>`;
            } else if(this.state.locale==='de') {
                return `<a href="https://www.infofauna.ch/de/daten/daten-beziehen#Kartenserver" target="_blank" class="left-panel-link" rel="noreferrer noopener">${match}</a>`;
            } else if(this.state.locale==='it') {
                return `<a href="https://www.infofauna.ch/it/dati/richiesta-dati#serveurcarto" target="_blank" class="left-panel-link" rel="noreferrer noopener">${match}</a>`;
            } else {
                return `<a href="https://www.infofauna.ch/fr/donnees/demander-des-donnees#serveurcarto" target="_blank" class="left-panel-link" rel="noreferrer noopener">${match}</a>`;
            }
        });

        const websiteLink = () => {
            if(this.state.locale==='fr') {
                return `https://www.infofauna.ch/fr/faune-de-suisse/${this.props.nuesp}`
            } else if(this.state.locale==='de') {
                return `https://www.infofauna.ch/de/fauna-der-schweiz/${this.props.nuesp}`
            } else if(this.state.locale==='it') {
                return `https://www.infofauna.ch/it/fauna-della-svizzera/${this.props.nuesp}`
            } else {
                return `https://www.infofauna.ch/fr/faune-de-suisse/${this.props.nuesp}`
            }
        }

        const bafuUrlsByLocale = {
            fr: 'https://www.bafu.admin.ch/fr/listesrouges',
            de: 'https://www.bafu.admin.ch/de/rotelisten',
            it: 'https://www.bafu.admin.ch/it/listerosse',
            en: 'https://www.bafu.admin.ch/en'
        }
        const bafuUrl = bafuUrlsByLocale[this.state.locale] ?? bafuUrlsByLocale['en'];

        return (
            <div className={this.state.openClass} disabled={this.state.panelDisabled}>
                <button onClick={this.openPanel} className="button-link left-panel-open-handle"
                   hidden={!this.state.panelHidden}>
                    <ThreeBarsIcon size='medium' verticalAlign='middle' className={this.state.iconClass}/>
                    <h2 className="left-panel-title">{this.state.species.genre === undefined ? textes.informations[this.state.locale] : this.state.species.genre + ' ' + this.state.species.espece + ' ' + this.state.species['ss_espece']}
                        &nbsp;&nbsp;
                        <small>{this.state.species[this.state.locale]}</small>
                    </h2>
                </button>
                <h5>&nbsp;</h5>
                <button hidden={this.state.panelHidden} onClick={this.closePanel}
                   className="button-link left-panel-close-handle">
                    <XIcon size='medium' verticalAlign='middle' className="left-panel-icon"/>
                </button>
                <p>
                    {this.state.species.ordre}<br/>
                    {this.state.species.famille}<br/>
                    <b className="big"><em>{this.state.species.genre} {this.state.species.espece} {this.state.species['ss_espece']}</em>&nbsp;&nbsp;</b>
                    <small>{this.state.species['auteur_annee']}</small>
                    <br/>
                    {this.state.species[this.state.locale]}
                </p>
                <p>
                    <span hidden={this.state.species[`niv_con_${this.state.locale}`] === null || this.state.species.niv_con_id === null}>
                        {this.state.species.niv_con_id && Number(this.state.species.niv_con_id)===1 
                            && <CheckCircleFillIcon size='small' className='left-panel-check-icon' />}
                        {this.state.species.niv_con_id && Number(this.state.species.niv_con_id)===2 
                            && <AlertFillIcon size='small' className='left-panel-alert-icon' />}
                        <span dangerouslySetInnerHTML={{ __html: linkedText }} />
                    </span>
                </p>
                <p><a className="left-panel-link" href={bafuUrl} target="_blank"
                      rel="noreferrer noopener">{textes.statut[this.state.locale]}</a> : <b>{this.state.species.lr ? this.state.species.lr: '-'}</b><br/>
                    <a className="left-panel-link" href={this.state.locale==='fr' ? "https://www.infospecies.ch/fr/esp%C3%A8ces/epn.html" : "https://www.infospecies.ch/de/arten/npa.html"}
                       target="_blank"
                       rel="noreferrer noopener">{textes.priorite[this.state.locale]}</a> : <b>{this.state.species.npa ? this.state.species.npa : '-'}</b><br/>
                    {textes.uzl[this.state.locale]} : <b>{this.state.species.uzl ? this.state.species.uzl : '-'}</b><br/>
                    {textes.wzl[this.state.locale]} : <b>{this.state.species.wzl ? this.state.species.wzl : '-'}</b><br/>
                    {textes.origine[this.state.locale]} : <b>{this.state.species.establishmentmeans}</b> ({this.state.species.establishmentmeans && establishmentmeans[this.state.species.establishmentmeans] ? establishmentmeans[this.state.species.establishmentmeans][this.state.locale] : ''})
                </p>
                <h5>{textes.legende[this.state.locale]}</h5>
                <p><img src={recent} alt="Couleur après année charnière" className="legend-pic"/> [<img src={rrecent} alt="Couleur après année charnière"/>] {textes.obsapres[this.state.locale]} {this.state.yrChange} [{textes.allochtone[this.state.locale]}]<br/>
                    <img src={older} alt="Couleur avant année charnière" className="legend-pic"/> [<img src={rolder} alt="Couleur après année charnière"/>] {textes.obsavant[this.state.locale]} {this.state.yrChange} [{textes.allochtone[this.state.locale]}]
                </p>
                <h5 hidden={this.state.images === null}>{textes.images[this.state.locale]}</h5>
                <p>
                    {
                        this.state.images ? this.state.images.map(image => {
                            return (
                                <img key={image} src={image} alt={image} className="min-image"
                                     onClick={() => this.openLighbox(image)}/>
                            )
                        }) : null
                    }
                </p>
                <Lightbox
                    open={images!=null && isOpen}
                    index={photoIndex}
                    close={() => this.setState({isOpen: false})}
                    slides={images!=null && images.map((image) => ({ src: image }))}
                    styles={{ container: { backgroundColor: "rgba(0, 0, 0, .85)" } }}    
                    plugins={[Zoom]}
                    zoom={{ scrollToZoom: true }}          
                />
                <div>
                    <h5>{textes.portrait[this.state.locale]}</h5>
                    <a className="left-panel-link" href={websiteLink()}
                        target="_blank" rel="noreferrer noopener">{textes.atlas[this.state.locale]}</a>
                </div>
                <br/><br/>
            </div>
        )
    }
}

export default LeftPanel;
